/** Determines whether the user's browser is Chrome. */
export default function chromeIs(): boolean
{
    return /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
}
